import { useContext, useEffect, useRef, useState } from 'react';
import { useGetProvidersFormat } from '../../hooks/useFormats';
import { ArteFinalContext_v2 } from '../../context/ArteFinalContext_v2';
import { ShoppingCartContext } from '../../context/ShoppingCartContext';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

const FormatSelected = ({ option, options, selected, showIconDropdown, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { shoppingCart_v2 } = useContext(ShoppingCartContext);
  const { formatSelected, formatProviderSelected, setFormatProviderSelected, arteFinal } =
    useContext(ArteFinalContext_v2);
  const { data: providers, isLoading } = useGetProvidersFormat(option.value, selected);
  // const [isProviderSelectOpen, setIsProviderSelectOpen] = useState(false);

  const tamañoStyle = { fontWeight: 'bold' };
  const materialStyle = { fontSize: '0.9rem !important', color: 'rgba(0, 0, 0, 0.54)' };

  const handleProviderChange = (value) => {
    if (shoppingCart_v2[arteFinal._id]?.formatos[formatSelected?.formatoId]?.quantity > 0) return;
    const selectedProvider = providers.data.find((provider) => provider._id === value);
    setFormatProviderSelected(selectedProvider);
  };

  useEffect(() => {
    // si es un formato custom, por defecto pondremos su primer proveedor
    if (option.formatoCustom && providers && providers.data.length > 0) {
      setFormatProviderSelected(providers.data[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (value) => {
    onChange(value);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const existsOnCart =
    shoppingCart_v2[arteFinal._id]?.formatos[formatSelected?.formatoId]?.quantity > 0 ||
    shoppingCart_v2[arteFinal._id]?.formatos[formatSelected?.formatoId]?.quantity;

  return option.formatoCustom ? (
    <div style={tamañoStyle}></div>
  ) : (
    <>
      <div
        ref={dropdownRef}
        className={`format-item  ${showIconDropdown ? 'has-icon' : ''} ${existsOnCart ? 'disabled' : ''}`}
        onClick={() => {
          if (!showIconDropdown) return;
          handleToggle?.();
        }}
      >
        <div>
          <div>
            <div style={tamañoStyle}>{option.formatName}</div>
            <div style={materialStyle}>{option.formatoMaterial || <i>Material no definido</i>}</div>
          </div>
          {showIconDropdown && (
            <>{!isOpen ? <IoIosArrowDown className="arrow-icon" /> : <IoIosArrowUp className="arrow-icon" />}</>
          )}
        </div>

        {isOpen && (
          <ul className="custom-dropdown-menu">
            {options.map((option) => (
              <li key={option.value} onClick={() => handleOptionClick(option.value)}>
                <div>
                  <div style={tamañoStyle}>{option.formatName}</div>
                  <div style={materialStyle}>
                    {option.formatoCustom ? (
                      <i>Material personalizado</i>
                    ) : (
                      option.formatoMaterial || <i>Material no definido</i>
                    )}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      {selected && !isLoading && providers && providers.data.length > 0 && (
        <div
          style={{
            border: '1px dotted #13121221',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '0.5rem',
          }}
        >
          {!existsOnCart && <strong>Selecciona proveedor:</strong>}
          <div
            className={`${
              !!shoppingCart_v2[arteFinal._id]?.formatos[formatSelected.formatoId]?.quantity > 0 ? 'cursor-default' : ''
            } custom-select-provider`}
            disabled={!!shoppingCart_v2[arteFinal._id]?.formatos[formatSelected.formatoId]?.quantity > 0}
            data-value={
              shoppingCart_v2[arteFinal._id]?.formatos[formatSelected.formatoId]
                ? shoppingCart_v2[arteFinal._id]?.formatos[formatSelected.formatoId].providerFormat._id
                : formatProviderSelected?._id || ''
            }
          >
            {providers.data
              .filter((i) => (existsOnCart ? i._id === formatProviderSelected?._id : true))
              .map((provider) => {
                const optionText = `${provider.code || 'Sin codigo'} - ${
                  provider?.provider?.shortName || 'Sin definir'
                }`;
                return (
                  <div
                    className={formatProviderSelected?._id === provider._id ? `selected` : ''}
                    key={provider._id}
                    onClick={() => handleProviderChange(provider._id)}
                  >
                    <i>{optionText}</i>
                    <span style={{ fontSize: '0.8rem', margin: '0 0.5rem' }}>-</span>
                    <strong>
                      {provider.price.toLocaleString('es-ES', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}{' '}
                      €
                    </strong>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </>
  );
};

export default FormatSelected;
